import React, { useState } from "react";
import { VerificationInput } from "../VerificationInput/VerificationInput";
import axios from "axios";
import { splitPhone } from "./Helpers";
import { useTranslation } from "react-i18next";

export default function VerificationCodeForm({ phone, onSubmit, tcpaMessage }) {
	const { t } = useTranslation();

	const [code, setCode] = useState();
	const [errorMessage, setErrorMessage] = useState("");
	const isValid = code?.length === 4;

	const onCheckCode = async (event) => {
		event.preventDefault();
		if (!phone) return;

		if (phone === "+38163549021" || phone === "063549021") {
			return;
		}

		const data = {
			code,
			country_code: splitPhone(phone).countryCode,
			phone: splitPhone(phone).rest
		};
		try {
			const response = await axios.post("/user/mfa-sms-verify", data);
			if (response?.data?.success) {
				onSubmit();
			} else setErrorMessage(t("CODE_YOU_ENTERED_IS_INVALID_"));
		} catch (error) {
			setErrorMessage(t("CODE_YOU_ENTERED_IS_INVALID_"));
		}
	};

	return (
		<form className="ad-form-verification-code" onSubmit={onCheckCode}>
			<span>Enter the code you received via sms:</span>
			<div>
				<VerificationInput value={code} onChange={(code) => setCode(code)} />
				{errorMessage && <span className="error-message">{errorMessage}</span>}
			</div>

			<button type="submit" disabled={!isValid}>
				{t("MENU_REQUEST")}
			</button>

			{tcpaMessage ? (
				<small className="tcpa-message">{tcpaMessage}</small>
			) : null}
		</form>
	);
}
